// import { Redirect } from "react-router-dom"
import { all, call, fork, put, takeEvery } from "redux-saga/effects"
import { getCustomerWishlisteApi } from "../../services/Api/CustomerWishListApi";
import { getCustomerAllWishList,getErrors} from "../reducers/CustomerWishListReducer"



// Watchers
function* customerWishListSaga() {
	yield takeEvery("customerWishList/getCustomerWishList", getCustomerWishList)
}

// Sagas
function* getCustomerWishList(action) {
// console.log(action.payload);
	try {
		const getCustomerWishlistData = yield call(getCustomerWishlisteApi, action.payload)
		
		if (getCustomerWishlistData.request.status === 200) {
            // console.log(getCustomerWishlistData);
			yield put(getCustomerAllWishList(getCustomerWishlistData))
		} else {
            // console.log(getCustomerWishlistData)
			yield put(getErrors(getCustomerWishlistData))
		}
	} catch (error) {
      
    
		yield put(getErrors(error))
	}
}

export default function* rootSaga() {
	yield all([fork(customerWishListSaga)])
}
